import { Box, Text } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import { currencyToNumber } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import CompareText from 'modules/payroll_bundle/components/CompareText'
import SummaryAmountList from 'modules/payroll_bundle/components/SummaryAmountList'
import {
  totalByCurrencyForPreviousPeriod,
  totalByTaxonomyForPreviousPeriod,
} from 'modules/payroll_bundle/hooks/useFetchSupplementInsights'
import type {
  SupplementsByTaxonomy,
  TotalByCurrency,
} from 'modules/payroll_bundle/pages/SupplementsPage/supplementsInsightsContext'

interface Props {
  open: boolean
  onClose: () => void
  totalByTaxonomy: SupplementsByTaxonomy[]
  previousTotalByTaxonomy: SupplementsByTaxonomy[]
  totalByCurrency: TotalByCurrency[]
  legalEntityCount: number
  previousTotalByCurrency: TotalByCurrency[]
}

const SupplementsInsightsSidePanel = ({
  totalByCurrency,
  previousTotalByCurrency,
  totalByTaxonomy,
  previousTotalByTaxonomy,
  legalEntityCount,
  open,
  onClose,
}: Props) => {
  const totalByTaxonomyNonZero = totalByTaxonomy.filter((taxonomy) => {
    const total = Number(taxonomy.total)
    return total !== 0 && !isNaN(total)
  })
  const totalByCurrencyNonZero = totalByCurrency.filter((currency) => {
    const total = Number(currency.total)
    return total !== 0 && !isNaN(total)
  })

  return (
    <Sidepanel
      overlay={false}
      boxPadding={false}
      width="narrow"
      onClose={onClose}
      open={open}
      closeLabel={i18n.t('common.close')}
    >
      <Box padding="s24" width="full">
        <Box paddingY="s24">
          <Box alignSelf="center">
            <Text color="grey800" size="400" weight="medium">
              {i18n.t('payroll_bundle.insights_from_supplements.supplements_totals')}
            </Text>
          </Box>
          <Box
            width="full"
            flexDirection="row"
            flexWrap="wrap"
            justifyContent={totalByCurrencyNonZero.length > 1 ? 'spaceBetween' : 'center'}
            paddingBottom="s12"
          >
            {totalByCurrencyNonZero.map((el) => {
              const currentTotal = el.total
              const previousTotal = previousTotalByCurrency
                ? totalByCurrencyForPreviousPeriod(previousTotalByCurrency, el.currency)
                : 0
              const totalDiff = currentTotal - previousTotal
              return (
                <Box key={el.currency} padding="s12" alignItems="center">
                  <Box paddingY="s12" paddingX="s6">
                    <Text weight="medium" size="400" color="grey1000">
                      {i18n.formatNumber(currentTotal / 100, 'currency', el.currency)}
                    </Text>
                  </Box>
                  {totalDiff && <CompareText amount={totalDiff} currency={el.currency} />}
                </Box>
              )
            })}
          </Box>
        </Box>
        <SummaryAmountList
          summaryAmountList={totalByTaxonomyNonZero.map((taxonomy) => ({
            name: taxonomy.taxonomyName,
            subtitle: legalEntityCount > 1 ? taxonomy.legalEntityName : '',
            amountCurrentPeriod: currencyToNumber(taxonomy.total),
            amountPreviousPeriod: totalByTaxonomyForPreviousPeriod(
              previousTotalByTaxonomy,
              taxonomy.taxonomyId
            )
              ? currencyToNumber(
                  totalByTaxonomyForPreviousPeriod(previousTotalByTaxonomy, taxonomy.taxonomyId)
                )
              : undefined,
            currency: taxonomy.legalEntityCurrency,
          }))}
        />
      </Box>
    </Sidepanel>
  )
}

export default SupplementsInsightsSidePanel
